import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, type AnyRouter } from "@tanstack/react-router";
import { I18nextProvider } from "react-i18next";

import { setTokenProvider } from "@/api/client";
import { AuthProvider } from "@/auth/auth-provider";
import { useAuth } from "@/auth/use-auth";
import { i18n } from "@/app/i18n";
import { queryClient } from "@/app/query-client";

type AppProvidersProps = {
  router: AnyRouter;
};

export function AppProviders({ router }: AppProvidersProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TokenBridge />
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

function TokenBridge() {
  const auth = useAuth();
  setTokenProvider(auth.getToken);
  return null;
}
